import { createContext } from 'react'

import { createContextMenuStore } from '../store/createStore'

export const ContextMenuStoreContext = createContext<
  ReturnType<typeof createContextMenuStore> | undefined
>(undefined)
